import { BaseResponseAttributes } from "../attributes/base-attributes";
import { RestApiResponse } from "./RestApi";
import BaseService from "./BaseService";

export class CityService extends BaseService {
  static async supportedCities(
    countryId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return CityService.getPublicApiClient().get(
      `countries/${countryId}/cities`
    );
  }
}

export default CityService;
